import { useContext } from 'react';
import { AuthContext } from '@urbanx/agx.auth.client';

const useLogout = () => {
  const { logout } = useContext(AuthContext);

  return logout;
};

export default useLogout;
